import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cb5c3d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 radius-7" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "mb-0" }, "Cameras")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "d-sm-flex align-items-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-flex me-10 mb-10 mb-lg-0 text-decoration-none ms-0 align-items-center fit-content",
  href: "#",
  "data-bs-toggle": "modal",
  "data-bs-target": "#CreateCameraModal"
}, [
  /*#__PURE__*/_createTextVNode(" Criar nova camera "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-video-camera-1 position-relative ms-5 fs-16 d-flex" })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25 mt-10" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " Nome "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " url "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " IA "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Gravando "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Data de criação "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " status "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, " Editar ")
  ])
], -1))
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { class: "camera-url-wrapper" }
const _hoisted_16 = { class: "camera-url-text" }
const _hoisted_17 = ["title", "onClick"]
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = {
  key: 0,
  class: "ai-region-status d-block mt-1"
}
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-center pe-0 d-flex justify-content-end" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-polygon position-relative fs-16 d-flex" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-edit position-relative fs-16 d-flex" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeleteCameraModal = _resolveComponent("DeleteCameraModal")!
  const _component_CreateCameraModal = _resolveComponent("CreateCameraModal")!
  const _component_UpdateCameraModal = _resolveComponent("UpdateCameraModal")!
  const _component_AiMonitoringRegionModal = _resolveComponent("AiMonitoringRegionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DeleteCameraModal),
    _createVNode(_component_CreateCameraModal),
    _createVNode(_component_UpdateCameraModal),
    _createVNode(_component_AiMonitoringRegionModal, {
      camera: _ctx.regionCamera,
      onSaved: _ctx.handleRegionSaved
    }, null, 8, ["camera", "onSaved"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_ctx.getConfigurations.adm)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCameras, (value, key) => {
                return (_openBlock(), _createElementBlock("tr", { key: key }, [
                  _createElementVNode("th", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(value.name), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(value.url), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "copy-url-button",
                        title: _ctx.copiedCameraId === value.id ? 'URL copiada' : 'Copiar URL',
                        onClick: ($event: any) => (_ctx.copyCameraUrl(value))
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass([_ctx.copiedCameraId === value.id ? 'ph ph-check' : 'ph ph-copy', "position-relative fs-16 d-flex"])
                        }, null, 2)
                      ], 8, _hoisted_17)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_18, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["ai-status-badge", _ctx.getAiStatusClass(value)])
                    }, _toDisplayString(_ctx.getAiStatusLabel(value)), 3),
                    (value.ai_monitoring_enabled)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_19, _toDisplayString(_ctx.hasAiRegion(value) ? 'Perímetro configurado' : 'Quadro inteiro'), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_20, [
                    _createElementVNode("i", {
                      class: _normalizeClass([{'ph ph-x-circle': !value.record, 'ph ph-check-circle': value.record}, "lh-1 position-relative top-1 fs-16"])
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(value.record == 1 ? 'Sim' : 'Não'), 1)
                  ]),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(value.created_at), 1),
                  _createElementVNode("td", {
                    class: _normalizeClass([{'active-column': value.active, 'inactive-column': !value.active}, "shadow-none lh-1 fw-medium text-black-emphasis"])
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass([{'ph ph-x-circle': !value.active, 'ph ph-check-circle': value.active}, "lh-1 position-relative top-1 fs-16"])
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(value.active == 1 ? 'Ativo' : 'Inativo'), 1)
                  ], 2),
                  _createElementVNode("td", _hoisted_22, [
                    (_ctx.getConfigurations.adm && value.ai_monitoring_enabled)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "position-relative transition border-0 fw-medium text-white p-10 rounded-1 bg-warning d-flex ms-5 mt-5 me-5 mb-5 text-decoration-none fit-content",
                          href: "#",
                          title: "Configurar perímetro de monitoramento IA",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#AiMonitoringRegionModal",
                          onClick: ($event: any) => (_ctx.openRegionEditor(value))
                        }, _hoisted_25, 8, _hoisted_23))
                      : _createCommentVNode("", true),
                    _createElementVNode("a", {
                      class: "position-relative transition border-0 fw-medium text-white p-10 rounded-1 bg-info d-flex ms-5 mt-5 me-5 mb-5 text-decoration-none ms-0 fit-content",
                      href: "#",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#UpdateCameraModal",
                      onClick: ($event: any) => (_ctx.setCurrentCamera(value))
                    }, _hoisted_28, 8, _hoisted_26)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}